import { getBaseAppParams } from '@/helper'
import logger from '@/helper/logger'
import { Ad, Game, TGASDK } from '@kulee/tga-sdk'
import { ENV, KULEWEBVIEW } from './constant'

const TGASDKInit = async () => {
  const { lang, theme, appCode } = await getBaseAppParams()

  const featureWalletConfig: any = {}

  // bip非土耳其地区，只显示养成币
  if (appCode === 'bip' && KULEWEBVIEW) {
    // const { country: code } = await window.Bridge.system.getCountry()
    // if (['tr', 'sg'].indexOf(code.toLowerCase()) < 0) {
    //   featureWalletConfig.display = ['GOLD']
    // }
  }

  await TGASDK.init({
    env: ENV,
    appCode,
    appConfig: {
      lang,
      defaultTheme: theme ? theme : undefined,
      // defaultTheme: 'dark',
      feature: {
        wallet: {
          ...featureWalletConfig
        }
      }
    }
  })

  TGASDK.addModule(Game)
  TGASDK.addModule(Ad)

  logger.log('appConfig', TGASDK.context.appConfig)
}

export { TGASDKInit }

export default TGASDK
